import { createFileRoute } from "@tanstack/react-router";

import { HubIndexPage, hubQuery } from "@/components/hubs/HubIndexPage";
import { buildHreflangLinks, buildLocaleMeta } from "@/lib/i18n-paths";

const PATH = "/national-parks";

export const Route = createFileRoute("/national-parks/")({
  loader: ({ context }) => context.queryClient.ensureQueryData(hubQuery("national-parks")),
  head: ({ loaderData }) => {
    const hub = (loaderData as any)?.hub;
    const places = ((loaderData as any)?.places ?? []) as { name: string; slug: string }[];
    const url = `https://whatfinland.com${PATH}`;
    const title = hub?.seo_title || "National parks in Finland — all 41 parks | what Finland";
    const desc =
      hub?.seo_description ||
      "Every national park in Finland: location, municipality, size, how to get there and what to do.";
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:type", content: "website" },
        { property: "og:url", content: url },
        ...buildLocaleMeta("en"),
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...buildHreflangLinks(PATH)],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ItemList",
            name: "National parks in Finland",
            url,
            numberOfItems: places.length,
            itemListElement: places.map((p, i) => ({
              "@type": "ListItem",
              position: i + 1,
              name: p.name,
              url: `${url}/${p.slug}`,
            })),
          }),
        },
      ],
    };
  },
  component: () => <HubIndexPage slug="national-parks" locale="en" />,
});
